import React from 'react';
import DialogTitle from '@mui/material/DialogTitle';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import TextField from '@mui/material/TextField';
import DialogActions from '@mui/material/DialogActions';
import Button from '@mui/material/Button';
import { FormRow } from './../../components/FormRow';
import  Grid  from '@mui/material/Grid';
import  IconButton  from '@mui/material/IconButton';
import  CloseIcon  from '@mui/icons-material/Close';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { CARE_COMPONENT_OVERIG, CARE_COMPONENT_OPTIONS } from './../../constants/common';

export class ActivitiesDialog extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            name: '',
            careComponent: null,
            editableItem: this.props.editableItem
        };
    }

    nameChange = (evt) => this.setState({ name: evt.currentTarget.value });

    // the dialog instance outlives a single open, so a choice made for one category
    // would otherwise still be in state when the next one is opened
    currentCareComponent = () => {
        if (this.state.careComponent != null) {
            return this.state.careComponent;
        }
        const saved = this.props.editableItem ? this.props.editableItem.CareComponent : null;
        return saved == null ? CARE_COMPONENT_OVERIG : saved;
    }

    closeDialog = (isCanceled, dialogResult) => {
        this.setState({ careComponent: null });
        this.props.dialogAction(isCanceled, dialogResult);
    }

    onCancelClick = () => this.closeDialog(true)

    onSaveClick = () => this.closeDialog(false, {
        name: this.state.name,
        careComponent: this.currentCareComponent(),
        editableItem: this.props.editableItem,
        type: this.props.type
    })

    render = () => {

        return (
            <Dialog open={this.props.open}>
                <DialogTitle>
                    <Grid container>
                        <Grid item xs={10} style={{ alignSelf: 'center' }}>{this.props.actionTitle}</Grid>
                        <Grid item xs={2} style={{ textAlign: 'right' }}>
                            <IconButton onClick={this.onCancelClick}><CloseIcon /></IconButton>
                        </Grid>
                    </Grid>
                </DialogTitle>
                <DialogContent>
                    <div style={{ display: "flex", flexDirection: "column" }}>
                    <FormRow>
                        <TextField
                            name="Name"
                            required
                            label="Naam"
                            defaultValue={(this.props.editableItem) ? this.props.editableItem.Name : ""}
                            onChange={this.nameChange} />
                            </FormRow>
                    {this.props.isCategory &&
                        <FormRow>
                            <FormControl fullWidth style={{ marginTop: 16 }}>
                                <InputLabel id="care-component-label">Zorgcomponent</InputLabel>
                                <Select
                                    labelId="care-component-label"
                                    label="Zorgcomponent"
                                    value={this.currentCareComponent()}
                                    onChange={(e) => this.setState({ careComponent: e.target.value })}
                                >
                                    {CARE_COMPONENT_OPTIONS.map((option) =>
                                        <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                                    )}
                                </Select>
                            </FormControl>
                        </FormRow>}
                    </div>
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.onSaveClick} color="primary">OPSLAAN</Button>
                    <Button onClick={this.onCancelClick} color="primary">TERUG</Button>
                </DialogActions>
            </Dialog>
        );
    }
}
